import { Component, HostListener } from '@angular/core';
import { UnsavedChangesService } from './services/unsaved-changes.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'pptgen-frontend';

  constructor(private unsaved: UnsavedChangesService) {}

  @HostListener('window:beforeunload', ['$event'])
  beforeUnload(event: BeforeUnloadEvent): void {
    if (this.unsaved.isDirty()) {
      event.preventDefault();
      event.returnValue = '';
    }
  }
}
